// The languages a project's video calls may be transcribed in for AI meeting
// notes, as Amazon Transcribe codes. Mirrors CALL_LANGUAGES in the API's
// meeting-notes/call-languages.ts, which drops anything else.
//
// Fewer is better: the transcription guesses each speaker's language from the
// first second of a turn, choosing only among the project's languages, so
// every language listed is also a wrong guess it can make. A project whose
// calls are always in one language should list only that one.
export const MEETING_NOTES_LANGUAGES = [
  'fi-FI',
  'sv-SE',
  'en-US',
  'et-ET',
  'pl-PL',
  'ru-RU',
  'ro-RO',
  'sq-AL',
  'de-DE',
];

// What the API assumes when a project has set nothing.
export const DEFAULT_MEETING_NOTES_LANGUAGES = ['fi-FI'];

// A project's stored list, or the default; the API's callLanguagesOf.
export const meetingNotesLanguagesOf = (project) => {
  const stored = project && project.aiMeetingNotesLanguages;
  return Array.isArray(stored) && stored.length
    ? stored
    : DEFAULT_MEETING_NOTES_LANGUAGES;
};

// The API and Chime stop at five candidates.
export const MAX_MEETING_NOTES_LANGUAGES = 5;

// "suomi" / "Finnish": the browser's own language names in the UI language, so
// no locale keys are needed per language; the code itself when the browser
// has no name for it.
export const meetingNotesLanguageLabel = (code, uiLanguage) => {
  const tag = String(code || '').split('-')[0];
  if (!tag) return '';
  try {
    if (typeof Intl !== 'undefined' && Intl.DisplayNames) {
      const name = new Intl.DisplayNames([uiLanguage || 'fi'], {
        type: 'language',
      }).of(tag);
      if (name && name !== tag) return name;
    }
  } catch (e) {
    // An unknown UI locale or an old browser: fall through to the code.
  }
  return code;
};

// "suomi, ruotsi": the list as a sentence fragment.
export const meetingNotesLanguageList = (codes, uiLanguage) =>
  (Array.isArray(codes) ? codes : [])
    .map((code) => meetingNotesLanguageLabel(code, uiLanguage))
    .filter(Boolean)
    .join(', ');
